/*
 * Candidates Page  Messages
 *
 * This contains all the text for the Evaluation Modal component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.CandidatesPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Students',
  },
  searchInputPlaceholder: {
    id: `${scope}.searchInputPlaceholder`,
    defaultMessage: 'UID, Name, Email',
  },
  studentColumnLabel: {
    id: `${scope}.studentColumnLabel`,
    defaultMessage: 'Student',
  },
  ratingColumnLabel: {
    id: `${scope}.ratingColumnLabel`,
    defaultMessage: 'Rating',
  },
  contactColumnLabel: {
    id: `${scope}.contactColumnLabel`,
    defaultMessage: 'Contact',
  },
  languagesColumnLabel: {
    id: `${scope}.languagesColumnLabel`,
    defaultMessage: 'Languages',
  },
  locationColumnLabel: {
    id: `${scope}.locationColumnLabel`,
    defaultMessage: 'Location',
  },
  multipleCitiesLabel: {
    id: `${scope}.multipleCitiesLabel`,
    defaultMessage: 'Multiple',
  },
  profileCompletionColumnLabel: {
    id: `${scope}.profileCompletionColumnLabel`,
    defaultMessage: 'Profile Completion',
  },
  deleteStudentConfirmMessage: {
    id: `${scope}.deleteStudentConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete this Student?',
  },
  deleteSuccessMessage: {
    id: `${scope}.deleteSuccessMessage`,
    defaultMessage: 'Student deleted successfully',
  },
  exportConfirmMessage: {
    id: `${scope}.exportConfirmMessage`,
    defaultMessage:
      'Are you sure you want to export that result as a CSV file?',
  },
  exportButtonLabel: {
    id: `${scope}.exportButtonLabel`,
    defaultMessage: 'Export',
  },
  fileDownloaded: {
    id: `${scope}.fileDownloaded`,
    defaultMessage: 'File downloaded successfully',
  },
  noDataExport: {
    id: `${scope}.noDataExport`,
    defaultMessage: 'There is no data to export',
  },
});
